module.exports = __webpack_public_path__ + "img/gaishuai.4b97e009.png";